<div class="page-header">
  <app-page-title></app-page-title>
</div>

<section class="role-assign-container" aria-label="การมอบสิทธิ์ใช้งาน">
  <div class="role-toolbar">
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (activeIdChange)="onTabChange($event)" class="nav-pills">
      <!-- Everyone may delegate their own businesses; being an agent for someone else does not take that away (work item 173). -->
      <li [ngbNavItem]="'assign'">
        <button ngbNavLink>มอบสิทธิ์ใช้งาน</button>
      </li>
      <li [ngbNavItem]="'received'">
        <button ngbNavLink>สิทธิ์ที่ได้รับมอบ</button>
      </li>
    </ul>

    @if (activeTab === 'assign') {
      <button type="button" class="btn btn-primary role-add-button" (click)="openAddModal()">
        <i class="bi bi-plus-lg" aria-hidden="true"></i>
        เพิ่มการมอบสิทธิ์
      </button>
    }
  </div>

  @if (roleAssignments.length === 0) {
    <div class="role-empty-state">
      <div class="empty-icon" aria-hidden="true"><i class="bi bi-person-check"></i></div>
      <h4>{{ activeTab === 'assign' ? 'ยังไม่มีการมอบสิทธิ์' : 'ยังไม่ได้รับมอบสิทธิ์' }}</h4>
      <p>{{ activeTab === 'assign' ? 'เริ่มต้นมอบสิทธิ์ให้ผู้ใช้งานที่เกี่ยวข้องกับธุรกิจของคุณ' : 'เมื่อมีผู้มอบสิทธิ์ให้ รายการจะแสดงที่นี่' }}</p>
      @if (activeTab === 'assign') {
        <button type="button" class="btn btn-primary" (click)="openAddModal()">
          <i class="bi bi-plus-lg" aria-hidden="true"></i>
          เพิ่มการมอบสิทธิ์
        </button>
      }
    </div>
  } @else {
    <div class="d-none d-md-block table-responsive role-table-shell">
      <table class="table table-hover align-middle mb-0 role-table">
        <thead>
        <tr>
          <th scope="col" class="col-number">#</th>
          <th scope="col">{{ activeTab === 'received' ? 'ผู้มอบสิทธิ์' : 'ผู้รับมอบสิทธิ์' }}</th>
          <th scope="col">รายการที่มอบสิทธิ์</th>
          <th scope="col">วันที่บันทึก</th>
          <th scope="col">สถานะ</th>
          @if (activeTab === 'assign') {
            <th scope="col" class="col-actions">จัดการ</th>
          }
        </tr>
        </thead>
        <tbody>
          @for (assignment of roleAssignments; track assignment.id; let i = $index) {
            <tr>
              <td class="col-number">{{ i + 1 }}</td>
              <td class="assignee-cell">{{ assignment.assignee }}</td>
              <td>{{ assignment.assignedItems }}</td>
              <td class="timestamp-cell">{{ assignment.timestamp }}</td>
              <td>
                <span class="status-badge" [class]="getStatusClass(assignment.status)">{{ getStatusLabel(assignment.status) }}</span>
              </td>
              @if (activeTab === 'assign') {
                <td class="col-actions">
                  <div class="action-buttons">
                    <button type="button" class="btn btn-icon" aria-label="แก้ไขการมอบสิทธิ์" title="แก้ไข"
                            (click)="openEditModal(assignment)"><i class="bi bi-pencil"></i></button>
                    <button type="button" class="btn btn-icon danger" aria-label="ลบการมอบสิทธิ์" title="ลบ"
                            (click)="deleteAssignment(assignment)"><i class="bi bi-trash"></i></button>
                  </div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="d-md-none role-card-list">
      @for (assignment of roleAssignments; track assignment.id; let i = $index) {
        <article class="role-card">
          <div class="role-card-header">
            <span class="record-number">#{{ i + 1 }}</span>
            <span class="status-badge"
                  [class]="getStatusClass(assignment.status)">{{ getStatusLabel(assignment.status) }}</span>
          </div>
          <div class="role-card-name">{{ assignment.assignee }}</div>
          <dl class="role-card-details">
            <div>
              <dt>รายการที่มอบสิทธิ์</dt>
              <dd>{{ assignment.assignedItems }}</dd>
            </div>
            <div>
              <dt>วันที่บันทึก</dt>
              <dd>{{ assignment.timestamp }}</dd>
            </div>
          </dl>
          @if (activeTab === 'assign') {
            <div class="role-card-actions">
              <button type="button" class="btn btn-icon" aria-label="แก้ไขการมอบสิทธิ์"
                      (click)="openEditModal(assignment)"><i class="bi bi-pencil"></i></button>
              <button type="button" class="btn btn-icon danger" aria-label="ลบการมอบสิทธิ์"
                      (click)="deleteAssignment(assignment)"><i class="bi bi-trash"></i></button>
            </div>
          }
        </article>
      }
    </div>
  }
</section>
